import Vue from 'vue'
import Axios from 'axios'
import qs from 'qs'
import apiConfig from '../../config/api.config'
import {
  Modal,
  message
} from 'ant-design-vue'

// 创建axios实例
const service = Axios.create({
  baseURL: apiConfig.baseUrl, // 配置接口地址; 跨域时需要在url前加baseURl
  timeout: 160000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      config.data = {
        unused: 0
      } // 这个是关键点，加入这行就可以了,解决get,请求添加不上Content-Type
      config.paramsSerializer = (params) => {
        return qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    // console.log(response)
    // 对响应数据做点什么
    //   let dataObj = response.data
    //   let code = dataObj.code

    if (response.data.code === 401) {
      Modal.error({
        title: '提示',
        content: `token过期，请重新登录`,
        onOk: () => {
          //  FIXME 跳转到登录界面
          localStorage.setItem('Authorization', '')
          location.reload()
        }
      })
    } else if (response.data.code === 403) {
      Modal.error({
        title: '提示',
        content: response.data.message,
        onOk: () => {
        }
      })
    } else {
      return response
    }
  },
  error => {
    // 对响应错误做点什么
    if (error.message.includes('timeout')) {
      message.error('数据请求超时!')
    } else {
      errorHandlingFun(error)
    }
    return Promise.reject(error)
  }
)

// 请求错误status处理
const errorHandlingFun = (error) => {
  console.log(error)
  const statusCode = error.response.status
  const dataObj = error.response.data
  switch (statusCode) {
  case 401:
    Modal.error({
      title: '提示',
      content: `<p>${dataObj ? dataObj.errMsg : error.message}</p>`,
      onOk: () => {
        //  FIXME 跳转到登录界面
        localStorage.setItem('Authorization', '')
        location.reload()
      }
    })
    break
  default:
    message.error(error.message)
  }
}

// 终止请求
const CancelToken = Axios.CancelToken
// eslint-disable-next-line
window.abortRequest
// *************************** 发送axios请求 ***************************
/**
 * 请求方法示例
 * @param url  请求地址
 * @param type  请求类型
 * @param data  入参
 * @param params  用于post请求时url后传参，如果是get请求或不需要url传参则忽略次参数
 * @param success 成功回调
 * @param error 错误回调
 * @param headers 请求头
 * @param requestDataType 请求数据格式
 * @param async 是否异步
 * @param enableAbortRequest  是否可以终止请求
 * @returns {Promise<void>}
 */
const sendAxios = async ({
  url,
  type,
  data = {},
  params = {},
  success,
  error,
  headers = {},
  isDefHeaders = true,
  requestDataType,
  responseType,
  enableAbortRequest = false,
  loading = true
}) => {
  if (loading) {
    Vue.prototype.$setLoading(true)
  }
  // 设置可配置的请求头
  // 默认当前系统的access_token,
  // 如需要使用其他token,请在调用接口方法是单独设置headers
  let defHeaders = {
    'Authorization': localStorage.getItem('Authorization') || ''
  }
  let transformRequest = []
  // 以form-data的数据格式提交
  if (requestDataType === 'form-data') {
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8',
      ...headers
    }
    transformRequest = [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ]
  }
  if (isDefHeaders) {
    headers = Object.assign({}, defHeaders, headers)
  } else {
    headers = Object.assign({}, headers)
  }
  // 终止请求
  let abortFunc = null
  if (enableAbortRequest) {
    abortFunc = new CancelToken(function executor (c) {
      window.abortRequest = c
    })
  }
  // 成功回调
  let successCallBack = resp => {
    Vue.prototype.$setLoading(false)
    success(resp)
  }
  // 失败回调
  let errorCallBack = err => {
    Vue.prototype.$setLoading(false)
    console.log(err)
    if (error) {
      error(err)
    } else {
      // this.$message.error(err)
      console.log('请求错误:' + url)
      console.log(err)
    }
  }

  let otherSet = requestDataType === 'form-data' ? {
    transformRequest: transformRequest,
    cancelToken: abortFunc,
    responseType: responseType
  } : {
    cancelToken: abortFunc,
    responseType: responseType
  }
  let sendData = type.toLocaleString() === 'get' || type.toLocaleString() === 'delete' ? [{
    params: data,
    headers: headers,
    ...otherSet
  }] : [data, {
    params: params,
    headers: headers,
    ...otherSet
  }]
  await service[type](url, ...sendData)
    .then(successCallBack)
    .catch(errorCallBack)
}
export default sendAxios



// WEBPACK FOOTER //
// ./src/request/axios.config.js